var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":"primary","disabled":_vm.naoPodeAprovar},on:{"click":function($event){return _vm.confirmarAprovacao()}}},[_c('i',{staticClass:"fa fa-check-circle-o"}),_vm._v(" Aprovar")])
}
var staticRenderFns = []

export { render, staticRenderFns }